"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.object.assign.js");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _material = require("@mui/material");
var _Search = _interopRequireDefault(require("@mui/icons-material/Search"));
var _Close = _interopRequireDefault(require("@mui/icons-material/Close"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var TableTextSearchBox = function TableTextSearchBox(_a) {
  var handleUpdateValue = _a.handleUpdateValue,
    sx = _a.sx,
    placeholder = _a.placeholder,
    showIcon = _a.showIcon,
    variant = _a.variant,
    _b = _a.defaultValue,
    defaultValue = _b === void 0 ? '' : _b;
  var _c = (0, _react.useState)(defaultValue),
    value = _c[0],
    setValue = _c[1]; // Changing state triggers re-render
  var lastTimeout = (0, _react.useRef)(); // Changing ref does not trigger render
  var handleUpdateValueCB = (0, _react.useRef)(handleUpdateValue);
  var isInitialRender = (0, _react.useRef)(true);
  (0, _react.useEffect)(function () {
    // Ignore initial render
    if (isInitialRender.current) {
      isInitialRender.current = false;
      return;
    }
    lastTimeout.current = window.setTimeout(function () {
      handleUpdateValueCB.current(value);
      clearTimeout(lastTimeout.current);
      lastTimeout.current = undefined;
    }, 300);
    return function () {
      var _a;
      if ((_a = lastTimeout.current) !== null && _a !== void 0 ? _a : false) {
        clearTimeout(lastTimeout.current);
        lastTimeout.current = undefined;
      }
    };
  }, [value]);
  return (0, _jsxRuntime.jsx)(_material.TextField, {
    placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : 'Search',
    sx: __assign(__assign({}, sx), {
      minWidth: '120px'
    }),
    onChange: function onChange(e) {
      setValue(e.target.value);
    },
    value: value,
    InputProps: {
      startAdornment: showIcon ? (0, _jsxRuntime.jsx)(_material.InputAdornment, __assign({
        position: "start"
      }, {
        children: (0, _jsxRuntime.jsx)(_Search.default, {})
      })) : undefined,
      endAdornment: (0, _jsxRuntime.jsx)(_material.InputAdornment, __assign({
        position: "end"
      }, {
        children: (0, _jsxRuntime.jsx)(_material.IconButton, __assign({
          "aria-label": "clear search",
          onClick: function onClick() {
            return setValue('');
          },
          edge: "end"
        }, {
          children: value.length > 0 ? (0, _jsxRuntime.jsx)(_Close.default, {}) : null
        }))
      }))
    },
    variant: variant !== null && variant !== void 0 ? variant : 'standard'
  });
};
TableTextSearchBox.propTypes = {
  handleUpdateValue: _propTypes.default.func.isRequired,
  sx: _propTypes.default.object,
  placeholder: _propTypes.default.string,
  showIcon: _propTypes.default.bool,
  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
};
var _default = TableTextSearchBox;
exports.default = _default;